export default __webpack_public_path__ + "static/media/statsImage2 square updated.de7c05a1.svg";